// extracted by mini-css-extract-plugin
module.exports = {"Banner":"Banner_Banner__1gOSG","bannerContent":"Banner_bannerContent__2O6Il","bannerImage":"Banner_bannerImage__cYHyN","bannerSocialButtons":"Banner_bannerSocialButtons__XWpzI"};